export default __webpack_public_path__ + "static/media/bulb-off-min.a143357c.png";